module.exports = __webpack_public_path__ + "media/images/products/placeholder-200x200-192085b33f077df305e1d94396009c09.png";